import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function ArticlePreview() {
  const { t } = useTranslation();

  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="w-full lg:w-1/3">
            <span className="inline-flex px-4 py-1.5 rounded-full border border-foreground-200 text-xs text-foreground-600 mb-6">
              {t('about.tag')}
            </span>
            <div className="rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Minimal%20workspace%20with%20laptop%20showing%20spreadsheet%2C%20cream%20background%2C%20coffee%20cup%2C%20warm%20natural%20light%2C%20clean%20editorial%20photography%2C%20elevated%20European%20aesthetic%2C%20neutral%20tones%2C%20no%20text&width=500&height=650&seq=article-preview-01&orientation=portrait"
                alt="YOYBUY Spreadsheet руководство"
                className="w-full h-full object-cover"
                title="YOYBUY Spreadsheet полное руководство 2026"
              />
            </div>
          </div>

          <div className="w-full lg:w-2/3">
            <h2 className="text-2xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground-900 leading-tight">
              {t('about.title1')}
              <br />
              {t('about.title2')}
              <br />
              {t('about.title3')}
            </h2>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mt-6 max-w-xl">
              {t('about.summary')}
            </p>
            <Link
              to="/article/yoybuy-spreadsheet-guide"
              className="inline-flex items-center gap-2 mt-8 px-6 py-3 rounded-full bg-foreground-900 text-background-50 text-sm font-medium hover:bg-foreground-800 transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              {t('about.cta')}
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}